// extracted by mini-css-extract-plugin
export default {"wrapper":"Map_wrapper__xEhmg","side_content":"Map_side_content__PYb7p"};